import React from 'react';

export default function IconBellActive() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={14}
      height={14}
      fill="none"
    >
      <path
        stroke="#00ab6b"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.2}
        d="M12.25 10.5H1.75a11.01 11.01 0 0 0 1.167-4.94v-.31A4.08 4.08 0 0 1 7 1.167a4.08 4.08 0 0 1 4.083 4.083v.31c0 1.714.403 3.406 1.167 4.94ZM5.938 12.145c.181.402.59.688 1.062.688.473 0 .88-.286 1.062-.688"
      />
    </svg>
  );
}
